﻿const defaultSize: number = 21 as const;
const alphabet: string = "346789ABCDEFGHJKLMNPQRTUVWXYabcdefghijkmnpqrtwxyz" as const;
const mask: number = 63 as const;//(2 << Math.log2(alphabet.length - 1)) - 1;
const step: number = 44 as const;//-~((1.6 * mask * defaultSize) / alphabet.length);

/**
 * Creates a random string of characters
 * @returns {string} of 21 characters.
 */
export default function nanoid(): string {
	let id = "";
	while (true) {
		let bytes = crypto.getRandomValues(new Uint8Array(step));
		let j = step | 0;
		while (j--) {
			id += alphabet[bytes[j] & mask] || "";
			if (id.length >= defaultSize) return id;
		}
	}
}
